// Acts as a global event bus for message passing
// between components, usage shown below:
//   import eventHub from './actual-path-here'
//   send events with eventHub.$emit('some_event', data)
//   watch for events with eventHub.$on('some_event', data => {})

import Vue from 'vue'
export const eventHub = new Vue()
